module.exports = __webpack_public_path__ + "static/media/apporoach_man_img.ea17721e.png";